import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { CardMedia, Grid, Typography } from "@mui/material";
import { isMobile } from "react-device-detect";
export default function DialogCustoms(props) {
  const {
    open,
    isModel,
    imgModalError,
    imgModalSuccess,
    imgModalFinished,
    title,
    massage,
    massageDes,
    idBtnPrimary,
    idBtnSecondary,
    btnPrimary,
    btnSecondary,
    switchType,
    countDown,
    isCountDown,
  } = props;
  const handleClose = (type) => {
    if (switchType) {
      if (type === 1) {
        switchType(true);
      } else if (type === 0) {
        switchType(false);
      }
    }
    isModel(!open);
  };
  return (
    // ค่าที่ใช้ได้: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          width: isMobile ? "450px" : "auto",
          maxWidth: "100%", // ป้องกันล้นจอ
        },
      }}
    >
      <DialogTitle
        style={{
          paddingTop: "40px",
          alignSelf: "center",
        }}
      >
        <Grid>
          {imgModalError && (
            <CardMedia
              component="img"
              className="img-dialog"
              image={"../../../images/model_error-warning.png"}
              sx={{ width: 100 }}
              alt="warning"
            />
          )}
          {imgModalSuccess && (
            <CardMedia
              component="img"
              className="img-dialog"
              image={"../../../images/model_success.png"}
              sx={{ width: 100 }}
              alt="warning"
            />
          )}
          {imgModalFinished && (
            <CardMedia
              component="img"
              className="img-dialog"
              image={"../../../images/model_finished.png"}
              sx={{ width: 100 }}
              alt="warning"
            />
          )}
          <Grid>
            <Typography className="font-title font-24 font-weight-bold text-center">
              {title}
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: {
            xs: "8px", // 👈 มือถือ
            sm: "16px", // 👈 หน้าจอปกติ
          },
        }}
      >
        {/* {isCountDown && (
          <DialogContentText className="font-title text-center font-24 font-weight-bold">
            {countDown}
          </DialogContentText>
        )} */}
        <DialogContentText
          id="alert-dialog-description"
          className="font-title text-center font-22"
          dangerouslySetInnerHTML={{
            __html: isCountDown
              ? massage.split(" 15 ")[0] +
                " " +
                countDown +
                " " +
                massage.split(" 15 ")[1]
              : massage,
          }}
          style={{
            minWidth: "200px",
            whiteSpace: "pre-wrap",
          }}
        />
        {massageDes && (
          <DialogContentText
            id="alert-dialog-description"
            className="font-title text-center  font-20 "
            dangerouslySetInnerHTML={{ __html: massageDes }}
            style={{
              minWidth: isMobile ? "70vw" : "30vw",
              // whiteSpace: "pre-wrap"
            }}
          />
        )}
      </DialogContent>
      <DialogActions
        style={{
          paddingTop: "25px",
        }}
      >
        {btnPrimary && (
          // (checkuserinfo ? (
          //   <OpenApp
          //     href="https://dev-life.ktbst.co.th/Login" //TODO LINK KTBST LIFE
          //     className="btn-next-app font-20"
          //   >
          //     {btnPrimary}
          //   </OpenApp>
          // ) : (
          //   <Button onClick={() => handleClose(1)} className="btn-next font-20">
          //     {btnPrimary}
          //   </Button>
          // ))
          <Button
            id={idBtnPrimary}
            onClick={() => handleClose(1)}
            className="btn-primary font-20"
          >
            {btnPrimary}
          </Button>
        )}
      </DialogActions>
      <DialogActions>
        {btnSecondary && (
          <Button
            id={idBtnSecondary}
            onClick={() => handleClose(0)}
            className="btn-secondary-cancel font-20"
          >
            {btnSecondary}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
